import { TechnologyTypeModel } from 'types/models/TechnologyTypeModel';
import { TechnologyType } from 'types/Project/TechnologyType';

export const mapTechnologyTypeModelToTechnologyTypes = (
  technologyTypeModels: TechnologyTypeModel[],
): TechnologyType[] =>
  technologyTypeModels.reduce<TechnologyType[]>((acc, { id, name }) => (id ? [...acc, { id, name }] : acc), []);
